import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enTenants from './locales/en/tenants.json';
import enPayments from './locales/en/payments.json';
import enProperties from './locales/en/properties.json';
import enExpenses from './locales/en/expenses.json';
import enReports from './locales/en/reports.json';
import enSettings from './locales/en/settings.json';
import enContracts from './locales/en/contracts.json';
import enProposals from './locales/en/proposals.json';
import enLandlordOnboarding from './locales/en/landlordOnboarding.json';

import frCommon from './locales/fr/common.json';
import frDashboard from './locales/fr/dashboard.json';
import frTenants from './locales/fr/tenants.json';
import frPayments from './locales/fr/payments.json';
import frProperties from './locales/fr/properties.json';
import frExpenses from './locales/fr/expenses.json';
import frReports from './locales/fr/reports.json';
import frSettings from './locales/fr/settings.json';
import frContracts from './locales/fr/contracts.json';
import frProposals from './locales/fr/proposals.json';
import frLandlordOnboarding from './locales/fr/landlordOnboarding.json';

const resources = {
  en: {
    common: enCommon,
    dashboard: enDashboard,
    tenants: enTenants,
    payments: enPayments,
    properties: enProperties,
    expenses: enExpenses,
    reports: enReports,
    settings: enSettings,
    contracts: enContracts,
    proposals: enProposals,
    landlordOnboarding: enLandlordOnboarding
  },
  fr: {
    common: frCommon,
    dashboard: frDashboard,
    tenants: frTenants,
    payments: frPayments,
    properties: frProperties,
    expenses: frExpenses,
    reports: frReports,
    settings: frSettings,
    contracts: frContracts,
    proposals: frProposals,
    landlordOnboarding: frLandlordOnboarding
  }
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'dashboard', 'tenants', 'payments', 'properties', 'expenses', 'reports', 'settings', 'contracts', 'proposals', 'landlordOnboarding'],
    
    // Language detection order
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'dossiloc_language'
    },

    interpolation: {
      escapeValue: false // React already escapes values
    },

    react: {
      useSuspense: false
    }
  });

export default i18n;
